import { render } from "./PopupSwitchProfile.vue?vue&type=template&id=fd585234"
import script from "./PopupSwitchProfile.vue?vue&type=script&lang=js"
export * from "./PopupSwitchProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__